import store from "store";

// this is for form initialValues with translatable entities
// `firstLocaleValue` optionally prefills the first (default) locale;
// `fieldName` supports entities translated on another field (e.g. genders use `value`)
export default function getTranslationInitialValues(firstLocaleValue = '', fieldName = 'name') {
    const locales = store.getState().currentOrganization?.retrieved?.locales;

    if (!locales) {
        return {}
    }

    const translations = {};

    locales.forEach(locale => translations[locale] = {
        [fieldName]: locale === locales[0] ? firstLocaleValue : '',
    });

    return translations;
}
